module.exports = "https://health.dajiuxing.com.cn/img/assets/login/Verificationcodeicon.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Flogin%2FVerificationcodeicon.png
// module id = 7W2+
// module chunks = 93